<!-- Dialog header when in dialog mode -->
@if (isDialogMode) {
  <div class="dialog-header" mat-dialog-title>
    <div class="title-section">
      <mat-icon class="title-icon">description</mat-icon>
      <h2>Állománylista Előnézet</h2>
    </div>
    <button 
      mat-icon-button 
      class="close-button" 
      (click)="onCloseDialog()"
      title="Bezárás">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<div class="contract-list-preview" [class.dialog-content]="isDialogMode" [attr.mat-dialog-content]="isDialogMode ? '' : null">
  @if (excelData) {
    <div class="preview-header">
      <div class="file-info">
        <h3>
          <i class="icon-file-excel"></i>
          {{ excelData.filename }}
        </h3>
        <div class="file-stats">
          <span class="stat-item">
            <i class="icon-table"></i>
            {{ excelData.rows_count }} sor
          </span>
          <span class="stat-item">
            <i class="icon-columns"></i>
            {{ excelData.columns.length }} oszlop
          </span>
        </div>
      </div>
      
      <div class="preview-controls">
        @if (!showPreview && excelData.rows_count > maxPreviewRows) {
          <button mat-outlined-button (click)="onShowPreview()" class="btn-show-preview">
            <mat-icon>unfold_less</mat-icon>
            Csak előnézet ({{ maxPreviewRows }} sor)
          </button>
        }
        @if (showPreview) {
          <button mat-outlined-button (click)="onShowAllRows()" class="btn-show-all">
            <mat-icon>unfold_more</mat-icon>
            Összes sor megjelenítése ({{ excelData.rows_count }})
          </button>
        }
      </div>
    </div>

    <div class="rows-container">
      @if (previewRows.length > 0) {
        <mat-accordion class="rows-accordion" multi="true">
          @for (rowData of previewRows; track rowData.rowIndex) {
            <mat-expansion-panel class="row-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <i class="icon-row"></i>
                  {{ rowData.rowIndex }}. sor
                </mat-panel-title>
                <mat-panel-description>
                  @if (rowData.fields.length > 0) {
                    {{ getFieldValue(rowData.fields[0].value) }}
                    @if (rowData.fields.length > 1) {
                      • {{ getFieldValue(rowData.fields[1].value) }}
                    }
                  }
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="row-content">
                <div class="fields-list">
                  @for (field of rowData.fields; track field.column) {
                    <div class="field-item" [ngClass]="getFieldClass(field.column)">
                      <div class="field-row">
                        <div class="field-label" [class.important]="isImportantField(field.column)">
                          <i class="field-icon" 
                             [class.icon-user]="getFieldClass(field.column) === 'field-name'"
                             [class.icon-mail]="getFieldClass(field.column) === 'field-email'"
                             [class.icon-phone]="getFieldClass(field.column) === 'field-phone'"
                             [class.icon-location]="getFieldClass(field.column) === 'field-address'"
                             [class.icon-calendar]="getFieldClass(field.column) === 'field-date'"
                             [class.icon-file-text]="getFieldClass(field.column) === 'field-default'">
                          </i>
                          <span class="label-text">{{ field.column }}:</span>
                        </div>
                        <div class="field-value" [class.empty]="!getFieldValue(field.value)">
                          {{ getFieldValue(field.value) || '(üres)' }}
                        </div>
                        
                        <!-- Contract field mapping dropdown -->
                        @if (isContractField(field.column)) {
                          <div class="contract-dropdown">
                            <mat-form-field appearance="outline" class="dropdown-field">
                              <mat-label>Contracts tábla mező</mat-label>
                              <mat-select 
                                [value]="getSelectedField(rowData.rowIndex, field.column)"
                                (selectionChange)="onFieldMappingSelected(rowData.rowIndex, field.column, $event.value)">
                                <mat-option [value]="null">Nincs kiválasztva</mat-option>
                                @for (contractField of contractFields; track contractField.columnName) {
                                  <mat-option [value]="contractField.columnName">
                                    {{ contractField.displayName }} ({{ contractField.columnName }})
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                        
                        @if (field.matchStatus) {
                          <div class="match-status" 
                               [class]="field.matchStatus.statusType">
                            <mat-icon class="match-icon">
                              @if (field.matchStatus.statusType === 'success') {
                                check_circle
                              } @else if (field.matchStatus.statusType === 'new-entity') {
                                add_circle
                              } @else if (field.matchStatus.statusType === 'new-product') {
                                inventory_2
                              } @else {
                                error
                              }
                            </mat-icon>
                            <span class="match-text">{{ field.matchStatus.matchInfo }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      } @else {
        <div class="no-data">
          <i class="icon-alert-circle"></i>
          <p>Nincsenek megjeleníthető adatok</p>
        </div>
      }
    </div>

    @if (showPreview && excelData.rows_count > maxPreviewRows) {
      <div class="preview-footer">
        <p class="preview-note">
          <i class="icon-info"></i>
          Előnézet: {{ previewRows.length }} / {{ excelData.rows_count }} sor megjelenítve
        </p>
      </div>
    }
  } @else {
    <div class="no-file">
      <i class="icon-file-plus"></i>
      <h3>Nincs Excel fájl betöltve</h3>
      <p>Válasszon egy Excel fájlt az előnézet megjelenítéséhez</p>
    </div>
  }
</div>

<!-- Dialog actions when in dialog mode -->
@if (isDialogMode && excelData) {
  <div class="dialog-actions" mat-dialog-actions align="end">
    <button 
      mat-button 
      (click)="onCloseDialog()"
      class="cancel-button">
      <mat-icon>close</mat-icon>
      Bezárás
    </button>
    <button 
      mat-raised-button 
      color="primary"
      (click)="onProcessData()"
      [disabled]="isProcessing"
      class="process-button">
      <mat-icon>{{ isProcessing ? 'hourglass_empty' : 'upload' }}</mat-icon>
      {{ isProcessing ? 'Feldolgozás...' : 'Feldolgozás' }}
    </button>
  </div>
}